/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-16 21:08:09
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-04-05 11:46:33
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/DraggableModules/ContentGroup/ErrorNotice/index.tsx
 */
import React from 'react';

import css from './css.less';

import { InfoCircleOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const ErrorNotice = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { getVisibleCollapse, data = [], disabled } = props;

  const _s: string[] = useSelector(getVisibleCollapse(data));
  const returnData = React.useMemo(() => {
    if (data && data.length > 0) {
      if (_s.length === 0) {
        return (
          <div className={css.warning}>{getI18n('general.atLeastOne')}</div>
        );
      } else {
        return (
          <div className={css.container}>
            {!disabled && (
              <React.Fragment>
                {' '}
                <InfoCircleOutlined className={css.icon} />
                <span className={css.text}>
                  {getI18n('general.dragmodule')}
                </span>
              </React.Fragment>
            )}
          </div>
        );
      }
    } else {
      return <div className={css.warning}>{getI18n('general.atLeastOne')}</div>;
    }
  }, [_s]);
  return returnData;
};
export default ErrorNotice;
